import { lhwpath } from "../apiRoutes";
import { api } from "./rtkAPI";


export const Query = api.injectEndpoints({
    endpoints: (builder) => ({
        createQuery: builder.mutation<any, any>({
            query: (bodyData) => {
                return {
                    url: `${lhwpath}/global/product/query/v3/process`,
                    method: "POST",
                    body: bodyData,
                };
            },
        }),
        getProduct: builder.query<any, { status?: string; page?: number; limit?: number, sort: string }>(
            {
                query: ({ status, page, limit, sort }) => {
                    const params = new URLSearchParams();

                    if (status) params.append("status", status);
                    if (page) params.append("page", page.toString());
                    if (limit) params.append("limit", limit.toString());
                    if(sort) params.append("sort", sort);
                    return {
                        url: `${lhwpath}/global/product/query/v3/getAllQuery2?${params.toString()}`,
                        method: "GET",
                    };
                },
            }
        ),

    }),
});

export const { useCreateQueryMutation, useGetProductQuery } = Query;
